module.exports = __webpack_public_path__ + "media/components/Bazaarvoice/icons/chevron-up-1ea069a4173ebcc87d054ac81296cf66.svg";